import { Button, Modal } from "@gotts.ai/ui";

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  detail?: string;
  confirmLabel?: string;
  confirmVariant?: "danger" | "warning" | "default";
  loading?: boolean;
}

export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  detail,
  confirmLabel = "Confirm",
  confirmVariant = "default",
  loading,
}: ConfirmModalProps) {
  const btnClass =
    confirmVariant === "danger"
      ? "btn-danger"
      : confirmVariant === "warning"
        ? "btn-amber"
        : "";

  return (
    <Modal
      open={open}
      onOpenChange={(v) => {
        if (!v) onClose();
      }}
      title={title}
      size="sm"
    >
      <div className="space-y-4">
        <p className="text-sm leading-relaxed text-[var(--color-text-dim)]">
          {description}
        </p>
        {detail && (
          <div className="rounded border border-[var(--glass-border)] bg-[#1a1e28] px-3 py-2 font-mono text-xs text-[var(--color-text-muted)]">
            {detail}
          </div>
        )}
        <div className="flex justify-end gap-2 border-t border-[var(--glass-border)] pt-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
            className={btnClass}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
